import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { BadgeProps } from "@edgetier/global-components";
import {
    ExperienceDriverRating,
    IInteractionExperienceRatings,
    IInteractionsGetQueryParameters,
    RationaleType,
} from "@edgetier/watchtower-types";

/**
 * The three experience-driver dimensions, as the UI names them. The API's own vocabulary is bot / agent / product;
 * these identifiers exist so no component has to know that mapping.
 */
export enum ExperienceDriver {
    ProductProcess = "productProcess",
    BotHandling = "botHandling",
    AgentHandling = "agentHandling",
}

/** The rating per dimension. A dimension absent or null is unrated. */
export type ExperienceDriverRatings = Partial<Record<ExperienceDriver, ExperienceDriverRating | null>>;

/** The one-sentence rationale per dimension, for each dimension that has one. */
export type ExperienceDriverRationales = Partial<Record<ExperienceDriver, string>>;

export interface IExperienceDriverDescriptor {
    readonly label: string;
    readonly icon: IconDefinition;
    readonly ratingField: keyof IInteractionExperienceRatings;
    readonly rationaleType: RationaleType;
    /** The interactions query parameter that filters by this driver's rating. */
    readonly queryParameter: keyof Pick<
        IInteractionsGetQueryParameters,
        "agentExperienceRating" | "botExperienceRating" | "productExperienceRating"
    >;
}

export interface IExperienceDriverRatingDescriptor {
    readonly label: string;
    readonly color: BadgeProps["color"];
    readonly variant: BadgeProps["variant"];
    readonly icon: IconDefinition;
}
